"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _LeaderboardRowContent = _interopRequireDefault(require("./shared/LeaderboardRowContent"));

var _LeaderboardRowHeader = _interopRequireDefault(require("./shared/LeaderboardRowHeader"));

var _jsxRuntime = require("react/jsx-runtime");

var _templateObject;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var StyledWrapper = _styledComponents.default.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  margin-bottom: 0.75rem;\n"])));

var Wrapper = function Wrapper(_ref) {
  var translations = _ref.translations,
      row = _ref.row,
      isDutch = _ref.isDutch,
      isActive = _ref.isActive,
      isShowingMyBet = _ref.isShowingMyBet,
      isPreMatchLeaderboard = _ref.isPreMatchLeaderboard,
      hasPrizeOverride = _ref.hasPrizeOverride,
      showPrizeIcons = _ref.showPrizeIcons,
      onRowClicked = _ref.onRowClicked,
      activePickem = _ref.activePickem,
      activeBet = _ref.activeBet,
      table = _ref.table,
      setBetbar = _ref.setBetbar;
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(StyledWrapper, {
    children: [!isShowingMyBet && /*#__PURE__*/(0, _jsxRuntime.jsx)(_LeaderboardRowHeader.default, {
      isDutch: isDutch,
      isPreMatchLeaderboard: isPreMatchLeaderboard,
      isActive: isActive,
      row: row,
      onRowClicked: onRowClicked,
      hasPrizeOverride: hasPrizeOverride,
      showPrizeIcons: showPrizeIcons
    }), isActive && /*#__PURE__*/(0, _jsxRuntime.jsx)(_LeaderboardRowContent.default, {
      translations: translations,
      setBetbar: setBetbar,
      table: table,
      row: row,
      activePickem: activePickem,
      activeBet: activeBet
    })]
  });
};

var _default = Wrapper;
exports.default = _default;